import { useClientPortalPublicData } from '../hooks'

export const useClientPortalPublicContent = () => {
  const { dataClientPortalPublic, isUscisCase } = useClientPortalPublicData()

  const caseData = dataClientPortalPublic?.caseInfo
  const companyData = dataClientPortalPublic?.company
  const historyData = dataClientPortalPublic?.history

  const processingTimeData = dataClientPortalPublic?.processingTime?.processingTime?.estimatedTime
  const processingTimeTrendData = dataClientPortalPublic?.processingTimeTrend
  const inquiryDateTrendData = dataClientPortalPublic?.inquiryTimeTrend
  const scheduledAlertsData = dataClientPortalPublic?.alertSchedule
  const visaBulletinData = dataClientPortalPublic?.visaBulletin
  const visaBulletinTrendData = dataClientPortalPublic?.visaBulletinTrend

  const existsProcessingTimeData = !!processingTimeData
  const existsProcessingTimeTrendData = !!processingTimeTrendData && processingTimeTrendData.length > 0
  const existsInquiryDateTrendData = !!inquiryDateTrendData && inquiryDateTrendData.length > 0
  const existsVisaBulletinData = !!visaBulletinData
  const existsVisaBulletinTrendData = !!visaBulletinTrendData && visaBulletinTrendData.length > 0
  const existsScheduledAlertsData = !!scheduledAlertsData && scheduledAlertsData.length > 0

  const showsProcessingTimeSection =
    isUscisCase && (existsProcessingTimeData || existsProcessingTimeTrendData || existsInquiryDateTrendData)
  const showsVisaBulletinSection = isUscisCase && (existsVisaBulletinData || existsVisaBulletinTrendData)
  const showsOtherCriticalDates = isUscisCase && existsScheduledAlertsData

  return {
    caseData,
    companyData,
    historyData,
    showsProcessingTimeSection,
    showsVisaBulletinSection,
    showsOtherCriticalDates,
  }
}
